<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="部门编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.deptCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="部门名称" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.deptName">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getMain()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="部门">
                <el-button v-authority="'BACK_MENU5_M10_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getMain" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="tableTotal">
                <el-table-column prop="deptId" label="编号" />
                <el-table-column prop="fcCode" label="工厂" />
                <el-table-column prop="deptCode" label="部门编号" />
                <el-table-column prop="deptName" label="部门名称" />
                <el-table-column prop="deptLevel" label="部门等级" />
                <el-table-column prop="parentId" label="父级编号" />
                <el-table-column prop="whCode" label="关联通道" />
                <el-table-column prop="createTime" label="创建时间" />
                <el-table-column prop="updateTime" label="修改时间" />
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU5_M10_B2'" size="mini" type="primary" @click="updateD(scope.row)" plain icon="el-icon-edit-outline" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 配置通道 -->
        <el-dialog :style="$popups.popups(0.6,0.4)" class="fromDialog" title="配置通道" :close-on-click-modal="false" :visible.sync="editBoxShow" :model="mainObj">
            <el-form label-width="80px" :model="mainObj" :rules="rules" ref="mainObj" style="height:500px">
                <el-col :lg="8" :xl="8">
                    <el-form-item label="工厂" prop="fcCode">
                        <el-input v-model="mainObj.fcCode" disabled/>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="部门编号" prop="deptCode">
                        <el-input v-model="mainObj.deptCode" disabled/>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="部门名称" prop="deptName">
                        <el-input v-model="mainObj.deptName" disabled/>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="部门等级" prop="deptLevel">
                        <el-input v-model="mainObj.deptLevel" disabled/>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="父级编号" prop="parentId">
                        <el-input v-model="mainObj.parentId" disabled/>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="创建时间" prop="createTime">
                        <el-input v-model="mainObj.createTime" disabled/>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="8">
                    <el-form-item label="关联通道" prop="whCode">
                        <el-select v-model="mainObj.whCode" placeholder="请选择" filterable>
                            <el-option v-for="(item, index) in whList" :key="index" :label="item.whCode+' - '+item.whName" :value="item.whCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-form>
            <span slot="footer" class="dialog-footer footer-bottom">
        <el-button size="small" type="info" @click="editBoxShow = false">取 消</el-button>
        <el-button size="small" type="primary" @click="editRow">修 改</el-button>
      </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "department",
    data() {
        return {
            headerCellStyle: () => {
                return "background-color: #1f5cec";
            },
            pagination: {
                pageSize: 50,
                pageNum: 1,
                fcCode: localStorage.getItem("fcCode") || "",
                deptCode: "",
                deptName: "",
            },
            tableTotal:0,
            mainData: [],

            loading: 0, //加载中
            editBoxShow: false, //编辑框

            mainObj: {},
            rules: {
                whCode: [{
                    required: true,
                    message: "请选择",
                    trigger: "change",
                },],
            },
            whList: [],

            downloadLoading: false, //下载中

            logContent: "", //操作日志-内容
            logRemarks: "", //操作日志-备注
            // 输入框延时加载
            isSetTimeout: null,
        };
    },
    watch: {
        pagination: {
            handler(newVal) {
                clearTimeout(this.isSetTimeout)
                this.isSetTimeout = setTimeout(() => {
                    this.getMain(newVal);
                }, 1000)
            },
            deep: true,
        },
    },
    methods: {
        //获取数据
        getMain() {
            this.$http
                .request({
                    url: "/api/tepartment/getDepartmentData",
                    method: "GET",
                    showLoading: true,
                    params: {
                        pageSize: this.pagination.pageSize,
                        pageNum: this.pagination.pageNum,
                        fcCode: this.pagination.fcCode,
                        deptCode: this.pagination.deptCode,
                        deptName: this.pagination.deptName,
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.mainData = resp.data.list || [];
                        this.tableTotal = resp.data.total;
                    }
                })
                .catch((error) => {
                    this.$notify.error({
                        title: "失败",
                        message: "主数据获取失败！",
                    });
                });
        },

        //重置
        resetData(){
            this.pagination.deptCode = "";
            this.pagination.deptName = "";
        },

        //获取通道
        getWhCode() {
            this.$http
                .request({
                    url: "/api/warehouse/getWarehouseAll",
                    method: "GET",
                    params: {
                        fcCode: localStorage.getItem("fcCode") || "",
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.whList = resp.data.list || [];
                    }
                })
                .catch((error) => {
                    this.$notify.error({
                        title: "失败",
                        message: "通道获取失败！",
                    });
                });
        },

        //框打开
        updateD(row){
            this.getWhCode();
            this.editBoxShow = true;
            this.mainObj = row;
        },

        editRow(){
            if (this.submitForm("mainObj")) {
                this.$http
                    .request({
                        url: "/api/tepartment/updateDepartment",
                        method: "PUT",
                        data: this.mainObj,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$message({
                                message: "操作成功",
                                type: "success",
                            });
                            this.logRemarks = "department：通道关联成功";
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "warning",
                            });
                            this.logRemarks = "department：通道关联失败";
                        }
                        this.editBoxShow = false;
                        this.getMain();
                        this.logContent = JSON.stringify(this.mainObj)
                        this.systemLog();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "通道获取失败！",
                        });
                    });
            }
        },
        //表单验证
        submitForm(formName) {
            let r = Boolean;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    r = true;
                } else {
                    r = false;
                }
            });
            return r;
        },

        //表格导出
        downLoadFile() {
            this.downloadLoading = true;
            var paramsObj = {
                fcCode: this.pagination.fcCode,
                deptCode: this.pagination.deptCode,
                deptName: this.pagination.deptName,
                pageNum: 1,
                pageSize: 999999,
            }

            this.$http.request({
                url: '/api/tepartment/getDepartmentData',
                method: 'GET',
                showLoading: true,
                params: paramsObj
            }).then((resp) => {
                resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                    message: '查询失败'
                });
            })
        },
        downLoad(list) {
            import('@/libs/Export2Excel').then(excel => {
                const tHeader = ['编号', '工厂', '部门编号', '部门名称', '部门等级', '父级编号', '关联通道', '创建时间', '修改时间']
                const filterVal = ['deptId', 'fcCode', 'deptCode', 'deptName', 'deptLevel', 'parentId', 'whCode', 'createTime', 'updateTime']
                const data = this.formatJson(filterVal, list)
                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: '部门数据'
                })
                this.logContent = "导出"
                this.logRemarks = "department：导出部门数据"
                this.systemLog();
                this.downloadLoading = false
            })
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        },

        /**
         * 操作日志
         */
        systemLog() {
            let objData = {
                logType: "部门主数据",
                logContent: this.logRemarks || "",
                //logRemarks: this.logRemarks || "",
                logUser: localStorage.getItem("user") || "",
            };
            this.$http
                .request({
                    url: "api/log/insert",
                    method: "POST",
                    data: objData,
                })
                .then((resp) => {
                    this.logContent = "";
                    this.logRemarks = "";
                    if (resp.status == 100) {}
                })
                .catch((error) => {});
        },
    },
    activated(){
        /* 获取首页的数据 */
        this.getMain();
    },
};
</script>

<style scoped>
</style>